export default __webpack_public_path__ + "static/media/solidity.e09d3e94.svg";